import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisEmployeeEventSidebarQueryVariables = Types.Exact<{
  pghId: Types.Scalars['Int']['input'];
}>;


export type HrisEmployeeEventSidebarQuery = { __typename?: 'Query', HrisEmployeeEvent?: { __typename?: 'HrisEmployeeEvent', pghId: number, pghCreatedAt: string, remoteHrisId?: string | null, rawHrisData?: { [key: string]: any } | null, id: number, firstName: string, lastName: string, phoneNumber?: string | null, employmentStatus?: string | null, startDate?: string | null, terminationDate?: string | null } | null };

export type HrisEmployeeEventSidebarFragment = { __typename?: 'HrisEmployeeEvent', pghId: number, pghCreatedAt: string, remoteHrisId?: string | null, rawHrisData?: { [key: string]: any } | null, id: number, firstName: string, lastName: string, phoneNumber?: string | null, employmentStatus?: string | null, startDate?: string | null, terminationDate?: string | null };

export type HrisEmployeeEventPreviousQueryVariables = Types.Exact<{
  input: Types.HrisEmployeeEventsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type HrisEmployeeEventPreviousQuery = { __typename?: 'Query', HrisEmployeeEvents: { __typename?: 'HrisEmployeeEvents', objects: Array<{ __typename?: 'HrisEmployeeEvent', pghId: number, pghCreatedAt: string, remoteHrisId?: string | null, rawHrisData?: { [key: string]: any } | null, id: number, firstName: string, lastName: string, phoneNumber?: string | null, employmentStatus?: string | null, startDate?: string | null, terminationDate?: string | null }> } };

export const HrisEmployeeEventSidebarFragmentDoc = gql`
    fragment HrisEmployeeEventSidebar on HrisEmployeeEvent {
  pghId
  pghCreatedAt
  remoteHrisId
  rawHrisData
  id
  firstName
  lastName
  phoneNumber
  employmentStatus
  startDate
  terminationDate
}
    `;
export const HrisEmployeeEventSidebarDocument = gql`
    query HrisEmployeeEventSidebar($pghId: Int!) {
  HrisEmployeeEvent(pghId: $pghId) {
    ...HrisEmployeeEventSidebar
  }
}
    ${HrisEmployeeEventSidebarFragmentDoc}`;

/**
 * __useHrisEmployeeEventSidebarQuery__
 *
 * To run a query within a React component, call `useHrisEmployeeEventSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisEmployeeEventSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisEmployeeEventSidebarQuery({
 *   variables: {
 *      pghId: // value for 'pghId'
 *   },
 * });
 */
export function useHrisEmployeeEventSidebarQuery(baseOptions: Apollo.QueryHookOptions<HrisEmployeeEventSidebarQuery, HrisEmployeeEventSidebarQueryVariables> & ({ variables: HrisEmployeeEventSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisEmployeeEventSidebarQuery, HrisEmployeeEventSidebarQueryVariables>(HrisEmployeeEventSidebarDocument, options);
      }
export function useHrisEmployeeEventSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisEmployeeEventSidebarQuery, HrisEmployeeEventSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisEmployeeEventSidebarQuery, HrisEmployeeEventSidebarQueryVariables>(HrisEmployeeEventSidebarDocument, options);
        }
export type HrisEmployeeEventSidebarQueryHookResult = ReturnType<typeof useHrisEmployeeEventSidebarQuery>;
export type HrisEmployeeEventSidebarLazyQueryHookResult = ReturnType<typeof useHrisEmployeeEventSidebarLazyQuery>;
export type HrisEmployeeEventSidebarQueryResult = Apollo.QueryResult<HrisEmployeeEventSidebarQuery, HrisEmployeeEventSidebarQueryVariables>;
export const HrisEmployeeEventPreviousDocument = gql`
    query HrisEmployeeEventPrevious($input: HrisEmployeeEventsInput!, $pagination: PaginationInput) {
  HrisEmployeeEvents(input: $input, pagination: $pagination) {
    objects {
      ...HrisEmployeeEventSidebar
    }
  }
}
    ${HrisEmployeeEventSidebarFragmentDoc}`;

/**
 * __useHrisEmployeeEventPreviousQuery__
 *
 * To run a query within a React component, call `useHrisEmployeeEventPreviousQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisEmployeeEventPreviousQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisEmployeeEventPreviousQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useHrisEmployeeEventPreviousQuery(baseOptions: Apollo.QueryHookOptions<HrisEmployeeEventPreviousQuery, HrisEmployeeEventPreviousQueryVariables> & ({ variables: HrisEmployeeEventPreviousQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisEmployeeEventPreviousQuery, HrisEmployeeEventPreviousQueryVariables>(HrisEmployeeEventPreviousDocument, options);
      }
export function useHrisEmployeeEventPreviousLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisEmployeeEventPreviousQuery, HrisEmployeeEventPreviousQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisEmployeeEventPreviousQuery, HrisEmployeeEventPreviousQueryVariables>(HrisEmployeeEventPreviousDocument, options);
        }
export type HrisEmployeeEventPreviousQueryHookResult = ReturnType<typeof useHrisEmployeeEventPreviousQuery>;
export type HrisEmployeeEventPreviousLazyQueryHookResult = ReturnType<typeof useHrisEmployeeEventPreviousLazyQuery>;
export type HrisEmployeeEventPreviousQueryResult = Apollo.QueryResult<HrisEmployeeEventPreviousQuery, HrisEmployeeEventPreviousQueryVariables>;